/**
 * 应用 Providers
 */
import { Suspense } from 'react';
import { QueryProvider } from './QueryProvider';
import { AuthProvider } from '@/contexts/AuthContext';
import { AppUpdateProvider } from '@/contexts/AppUpdateProvider';
import { TaskEventStreamProvider } from '@/hooks/events';

interface AppProvidersProps {
  children: React.ReactNode;
}

export function AppProviders({ children }: AppProvidersProps) {
  return (
    <QueryProvider>
      <AppUpdateProvider>
        <AuthProvider>
          <TaskEventStreamProvider>
            <Suspense fallback={<div>Loading...</div>}>{children}</Suspense>
          </TaskEventStreamProvider>
        </AuthProvider>
      </AppUpdateProvider>
    </QueryProvider>
  );
}

export { QueryProvider } from './QueryProvider';
